import { render, staticRenderFns } from "./pypView.vue?vue&type=template&id=01644ec6&scoped=true"
import script from "./pypView.vue?vue&type=script&lang=js"
export * from "./pypView.vue?vue&type=script&lang=js"
import style0 from "./pypView.vue?vue&type=style&index=0&id=01644ec6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01644ec6",
  null
  
)

export default component.exports